<template>
	<div class="footer">
		<div class="webMes mainW">
			<div class="flex-start">
				<div class="guide">
					<div class="link">
						<router-link tag="span" class="cursor" :to="{ path: '/index?id=1' }">采购课程</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/index?id=3' }">招投标课程</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/index?id=2' }">供应链课程</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/index?id=4' }">CPPM课程</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/index?id=5' }">SCMP课程</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/index?id=6' }">PMP课程</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/content?id=0' }">关于我们</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/content?id=1' }">联系客服</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/content?id=2' }">意见反馈</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/content?id=3' }">用户协议</router-link>
						<router-link tag="span" class="cursor" :to="{ path: '/content?id=4' }">隐私协议</router-link>
						<!-- <router-link tag="span" class="cursor" :to="{path:'/content?id=4'}">友情链接</router-link> -->
						<a class="cursor" style="color: #DBDDDE; font-size: 15px" target="_blank"
							href="http://www.zzpxedu.com/">众智商学院官网</a>
					</div>
					<div class="flex-space mes">
						<div class="flex-alitem"><img src="../../../static/index/phone.png" width="16px" height="16px"
								alt="">全国统一热线：400-068-2368</div>
						<div class="flex-alitem"><img src="../../../static/index/address.png" width="16px" height="16px"
								alt="">公司地址：北京市丰台区北大街14号</div>
						<div class="flex-alitem">邮箱：8021839@qq.com</div>
					</div>
				</div>
				<div class="flex-space tc code">
					<div class="">
						<img src="../../../static/code.png" alt="" width="106px" height="106px">
						<div>扫一扫 立即关注</div>
					</div>
					<div>
						<img src="../../../static/code.png" alt="" width="106px" height="106px">
						<div>APP下载</div>
					</div>
				</div>
			</div>

		</div>
		<div class="webText">
			<div class="mainW">
				<span class="copyRight">Copyright@2018 All rights </span> <span
					class="liRight">网站备案许可证号：京ICP备19010045号-1</span>
				<span class="shuangRight">PMI, PMP, Project Management Professional, PMI-ACP, PMI-PBA 和 PMBOK 是 Project
					Management Institute, Inc. 的注册商标</span>

			</div>
		</div>
		<div class="chatGpt">
			<ChatGpt></ChatGpt>
		</div>
	</div>
</template>

<script>
import ChatGpt from "@/components/ChatGpt/index.vue";
export default {
	components: {
		ChatGpt
	},
	name: 'PageFooter',
	data() {
		return {
			content: '',
			address: ''
		}
	},
	created() {

	},
	methods: {

	}
}		
</script>

<style scoped lang="less">
.footer {
	background-color: #232323;
	color: #e5e5e5;

	.webMes {
		padding: 30px 0;

		.guide {
			width: 900px;

			.link {
				span {
					display: inline-block;
					width: 130px;
					color: #DBDDDE;
					margin-bottom: 15px;
					font-size: 15px;
				}
			}

			.mes {
				font-size: 14px;
				color: #86898A;
				width: 735px;
				margin-top: 10px;

				img {
					margin-right: 12px;
				}
			}
		}

		.code {
			width: 300px;
			color: #586063;
			font-size: 15px;

			img {
				margin-bottom: 5px;
				display: inline-block;
			}
		}
	}

	.webText {
		background-color: #1C1C1C;
		line-height: 50px;
		opacity: .6;
		font-size: 14px;

		.mainW {
			margin-top: 10px;
			display: flex;
			justify-content: space-between;
		}

		.copyRight {
			// margin-right: 200px;
		}

		.liRight {
			// margin-right: 100px;
		}

		.shuangRight {
			display: block;
			width: 400px;
			line-height: 20px;
			margin-top: 5px;
			font-size: 12px;
		}
	}

	.chatGpt {
		position: fixed;
		bottom: 2px;
		right: 2px;
		z-index: 10;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/PageFooter/index.vue